import {Toast} from 'antd-mobile';

window.WeChatPay = {};

// eslint-disable-next-line no-undef
WeChatPay.Base = (function(){
   var uniqInstance;
   function init(){
      var WeChatPay = function(payArgs,callback){
         try{
               var payParams = {
                  "appId":payArgs.appId,
                  "timeStamp":payArgs.timeStamp,
                  "nonceStr":payArgs.nonceStr,
                  "package":payArgs.packages,
                  "signType":"MD5",           
                  "paySign":payArgs.sign
               };
               // eslint-disable-next-line no-undef
               WeixinJSBridge.invoke('getBrandWCPayRequest',
                     payParams,
                     function(res){
                        callback(res);
               });
         }
         catch(e)
         {
            Toast.info("支付失败");
         }
      }
      return {
         WeChatPay:function(payArgs,callback){
            return WeChatPay(payArgs,callback)
         }
      }
   }

   return {
      getInstance:function(){
         if(!uniqInstance) {
            uniqInstance = init()
        }
        return uniqInstance;
      }
   }
})();
